// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".watermark{border:4px solid rgba(255,5,5,.17);border-radius:10px;color:rgba(255,5,5,.17);font-size:42px;padding-bottom:35px;padding-top:35px;position:absolute;text-transform:uppercase;top:44%;transform:rotate(331deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
